import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精品分类
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            六大品类，每一件都经过严格甄选
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-300 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">
                {cat.nameEn}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}